import React, { useEffect, useRef } from "react"
import * as d3 from "d3"
import * as Math from "mathjs"
import { log } from "mathjs"

import Box from '@material-ui/core/Box'

const Output1 = (props) => {
  const ref = useRef()
  useEffect(() => {

    let dimensions = {
      width: 1100,
      height: 600,
      margin: {
        top: 20,
        right: 10,
        bottom: 50,
        left: 50
      }
    }

    dimensions.boundedWidth = dimensions.width - dimensions.margin.left - dimensions.margin.right
    dimensions.boundedHeight = dimensions.height - dimensions.margin.top - dimensions.margin.bottom

    const svgElement = d3.select(ref.current).attr("width", dimensions.width).attr("height", dimensions.height)

    svgElement.selectAll('*').remove()

    const bounds = svgElement.append("g").style("transform", `translate(${dimensions.margin.left}px, ${dimensions.margin.top}px)`)

    // Data Retrieve and process data => x*beta
    console.log(props.data)
    let {
      age,
      ca125,
      pln,
      nac,
      sbm1,
      sbm2,
      opt1,
      opt2

    } = props.data

    // Process Data: Standardize & Age transformation

    // Calculate Coef and etc from R

    const coef0 = -5.693
    const [coef1, coef2, coef5, coef6, coef7, coef8, coef9, coef10] =
      [
        0.031,
        0.213,
        0.823,
        1.039,
        0.812,
        0.672,
        0.444,
        -0.166
      ]
    const [ageMin, ca125Min, plnMin, nacMin, sbm1Min, sbm2Min, opt1Min, opt2Min] = [
      Math.min(coef1 * (20), coef1 * (100)),
      Math.min(coef2 * log(2.7), coef2 * log(45200)),
      Math.min(coef5 * 0, coef5 * 1),
      Math.min(coef6 * 0, coef6 * 1),
      Math.min(coef7 * 0, coef7 * 1),
      Math.min(coef8 * 0, coef8 * 1),
      Math.min(coef9 * 0, coef9 * 1),
      Math.min(coef10 * 0, coef10 * 1)
    ]
    // Max는 coef가 곱해진 값이다!!
    const [ageMax, ca125Max, plnMax, nacMax, sbm1Max, sbm2Max, opt1Max, opt2Max] = [
      Math.max(coef1 * (20), coef1 * (100)),
      Math.max(coef2 * log(2.7), coef2 * log(45200)),
      Math.max(coef5 * 0, coef5 * 1),
      Math.max(coef6 * 0, coef6 * 1),
      Math.max(coef7 * 0, coef7 * 1),
      Math.max(coef8 * 0, coef8 * 1),
      Math.max(coef9 * 0, coef9 * 1),
      Math.max(coef10 * 0, coef10 * 1)
    ]
    // Calculating
    const ageVal = age * coef1
    const ca125Val = ca125 * coef2
    const plnVal = pln * coef5
    const nacVal = nac * coef6
    const sbm1Val = sbm1 * coef7
    const sbm2Val = sbm2 * coef8
    const opt1Val = opt1 * coef9
    const opt2Val = opt2 * coef10


    const agePoint = ageVal - ageMin
    const ca125Point = ca125Val - ca125Min
    const plnPoint = plnVal - plnMin
    const nacPoint = nacVal - nacMin
    const sbm1Point = sbm1Val - sbm1Min
    const sbm2Point = sbm2Val - sbm2Min
    const opt1Point = opt1Val - opt1Min
    const opt2Point = opt2Val - opt2Min

    const totalPoint = agePoint + ca125Point + plnPoint + nacPoint + sbm1Point + sbm2Point + opt1Point + opt2Point
    const maxPoint = ageMax + ca125Max + plnMax + nacMax + sbm1Max + sbm2Max + opt1Max + opt2Max - (ageMin + ca125Min + plnMin + nacMin + sbm1Min + sbm2Min + opt1Min + opt2Min)
    const logit = coef0 + ageVal + ca125Val + plnVal + nacVal + sbm1Val + sbm2Val + opt1Val + opt2Val
    const prob = Math.exp(logit) / (Math.exp(logit) + 1)

    console.log(coef2, ca125Point, ca125Val, ca125Max, ca125Min)
    console.log(coef0, ageVal, ca125Val, plnVal, nacVal, sbm1Val, sbm2Val, opt1Val, opt2Val)
    console.log(logit)



    //  Bar Animation
    let i = d3.piecewise(d3.interpolateRgb.gamma(1), (["green", "#F5E772", "#E32D50"]))
    // TotalBar
    const totalWidth = 6
    const totalBar = bounds.append("g").attr("transform", "translate(400,400)")
    const totalBarScale = d3.scaleLinear().domain([0, 100]).range([
      0, totalWidth * 100
    ])
    const totalBarAxisGenerator = d3.axisBottom().scale(totalBarScale)
    const totalBarText = totalBar.append("text").text("Total Points").attr("font-weight", "bold").attr("text-anchor", "start").attr("x", -440)
    const totalBarAxis = totalBar.append("g").call(totalBarAxisGenerator)
    const totalRect = totalBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", totalBarScale(100 * totalPoint / maxPoint)).attr("fill", i(totalPoint / maxPoint))
    const totalText = totalBar.append("text").transition().duration(1000).text(`${Math.round(100 * (totalPoint / maxPoint))}pt`).attr("x", totalBarScale(100 * (totalPoint / maxPoint) + 1)).attr("font-size", 14).attr("font-weight", "bold")
    // ageBar

    const ageBar = bounds.append("g").attr("transform", "translate(400,0)")

    const ageBarScale = d3.scaleLinear().domain([
      0, 100 * (ageMax - ageMin) / maxPoint
    ]).range([
      0, 100 * (ageMax - ageMin) / maxPoint * totalWidth
    ])
    const ageBarAxisGenerator = d3.axisBottom().scale(ageBarScale).ticks(5)
    const ageBarText = ageBar.append("text").text("Age").attr("x", -440).attr("font-weight", "bold").attr("text-anchor", "start")
    const ageBarAxis = ageBar.append("g").call(ageBarAxisGenerator)
    const ageRect = ageBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", ageBarScale(100 * (agePoint / maxPoint))).attr("fill", i(agePoint / (ageMax - ageMin)))
    const ageText = ageBar.append("text").transition().duration(1000).text(`${Math.round(100 * (agePoint / maxPoint))}pt`).attr("x", ageBarScale(100 * (agePoint / maxPoint) + 1)).attr("font-size", 14).attr("font-weight", "bold")
    // ca125 bar
    const ca125Bar = bounds.append("g").attr("transform", "translate(400,50)")

    const ca125BarScale = d3.scaleLinear().domain([
      0, 100 * (ca125Max - ca125Min) / maxPoint
    ]).range([
      0,
      (ca125Max - ca125Min) / maxPoint * totalWidth * 100
    ])
    const ca125BarAxisGenerator = d3.axisBottom().scale(ca125BarScale).ticks(5)
    const ca125BarText = ca125Bar.append("text").text(" ln [CA-125]").attr("text-anchor", "start").attr("x", -440).attr("font-weight", "bold")
    const ca125BarAxis = ca125Bar.append("g").call(ca125BarAxisGenerator)
    const ca125Rect = ca125Bar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", ca125BarScale(100 * (ca125Point / maxPoint))).attr("fill", i(ca125Point / (ca125Max - ca125Min)))
    const ca125Text = ca125Bar.append("text").transition().duration(1000).text(`${Math.round(100 * (ca125Point / maxPoint))}pt`).attr("x", ca125BarScale(100 * (ca125Point / maxPoint) + 1)).attr("font-size", 14).attr("font-weight", "bold")

    const plnBar = bounds.append("g").attr("transform", "translate(400,100)")

    const plnBarScale = d3.scaleLinear().domain([
      0, 100 * (((plnMax - plnMin) / maxPoint))
    ]).range([
      0,
      (((plnMax - plnMin) / maxPoint)) * totalWidth * 100
    ])
    const plnBarAxisGenerator = d3.axisBottom().scale(plnBarScale).ticks(2)
    const plnBarText = plnBar.append("text").text("Pelvic LN status").attr("text-anchor", "start").attr("x", -440).attr("font-weight", "bold")
    const plnBarAxis = plnBar.append("g").call(plnBarAxisGenerator)
    const plnRect = plnBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", plnBarScale(100 * (plnPoint / maxPoint))).attr("fill", i(plnPoint / (plnMax - plnMin)))
    const plnText = plnBar.append("text").transition().duration(1000).text(`${Math.round(100 * (plnPoint / maxPoint))}pt`).attr("x", plnBarScale(100 * (plnPoint / maxPoint) + 1)).attr("font-size", 14).attr("font-weight", "bold")

    const nacBar = bounds.append("g").attr("transform", "translate(400,150)")

    const nacBarScale = d3.scaleLinear().domain([
      0, 100 * (((nacMax - nacMin) / maxPoint))
    ]).range([
      0,
      (((nacMax - nacMin) / maxPoint)) * totalWidth * 100
    ])
    const nacBarAxisGenerator = d3.axisBottom().scale(nacBarScale).ticks(3)
    const nacBarText = nacBar.append("text").text("Primary treatment strategy").attr("text-anchor", "start").attr("x", -440).attr("font-weight", "bold")
    const nacBarAxis = nacBar.append("g").call(nacBarAxisGenerator)
    const nacRect = nacBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", nacBarScale(100 * (nacPoint / maxPoint))).attr("fill", i(nacPoint / (nacMax - nacMin)))
    const nacText = nacBar.append("text").transition().duration(1000).text(`${Math.round(100 * (nacPoint / maxPoint))}pt`).attr("x", nacBarScale(100 * (nacPoint / maxPoint) + 1)).attr("font-size", 14).attr("font-weight", "bold")

    const sbm1Bar = bounds.append("g").attr("transform", "translate(400,200)")

    const sbm1BarScale = d3.scaleLinear().domain([
      0, 100 * (((sbm1Max - sbm1Min) / maxPoint))
    ]).range([
      0,
      (((sbm1Max - sbm1Min) / maxPoint)) * totalWidth * 100
    ])
    const sbm1BarAxisGenerator = d3.axisBottom().scale(sbm1BarScale).ticks(3)
    const sbm1BarText = sbm1Bar.append("text").text("Small bowel and mesentery [Macroscopic (≤2cm)]").attr("text-anchor", "start").attr("x", -440).attr("font-weight", "bold")
    const sbm1BarAxis = sbm1Bar.append("g").call(sbm1BarAxisGenerator)
    const sbm1Rect = sbm1Bar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", sbm1BarScale(100 * (sbm1Point / maxPoint))).attr("fill", i(sbm1Point / (sbm1Max - sbm1Min)))
    const sbm1Text = sbm1Bar.append("text").transition().duration(1000).text(`${Math.round(100 * (sbm1Point / maxPoint))}pt`).attr("x", sbm1BarScale(100 * (sbm1Point / maxPoint) + 1)).attr("font-size", 14).attr("font-weight", "bold")

    const sbm2Bar = bounds.append("g").attr("transform", "translate(400,250)")

    const sbm2BarScale = d3.scaleLinear().domain([
      0, 100 * (((sbm2Max - sbm2Min) / maxPoint))
    ]).range([
      0,
      (((sbm2Max - sbm2Min) / maxPoint)) * totalWidth * 100
    ])
    const sbm2BarAxisGenerator = d3.axisBottom().scale(sbm2BarScale).ticks(2)
    const sbm2BarText = sbm2Bar.append("text").text("Small bowel and mesentery [Macroscopic (>2cm)]").attr("text-anchor", "start").attr("x", -440).attr("font-weight", "bold")
    const sbm2BarAxis = sbm2Bar.append("g").call(sbm2BarAxisGenerator)
    const sbm2Rect = sbm2Bar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", sbm2BarScale(100 * (sbm2Point / maxPoint))).attr("fill", i(sbm2Point / (sbm2Max - sbm2Min)))
    const sbm2Text = sbm2Bar.append("text").transition().duration(1000).text(`${Math.round(100 * (sbm2Point / maxPoint))}pt`).attr("x", sbm2BarScale(100 * (sbm2Point / maxPoint) + 1)).attr("font-size", 14).attr("font-weight", "bold")

    const opt1Bar = bounds.append("g").attr("transform", "translate(400,300)")

    const opt1BarScale = d3.scaleLinear().domain([
      0, 100 * (((opt1Max - opt1Min) / maxPoint))
    ]).range([
      0,
      (((opt1Max - opt1Min) / maxPoint)) * totalWidth * 100
    ])
    const opt1BarAxisGenerator = d3.axisBottom().scale(opt1BarScale).ticks(2)
    const opt1BarText = opt1Bar.append("text").text("Other pelvic tissue except uterus and tube [Microscopic]").attr("text-anchor", "start").attr("x", -440).attr("font-weight", "bold")
    const opt1BarAxis = opt1Bar.append("g").call(opt1BarAxisGenerator)
    const opt1Rect = opt1Bar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", opt1BarScale(100 * (opt1Point / maxPoint))).attr("fill", i(opt1Point / (opt1Max - opt1Min)))
    const opt1Text = opt1Bar.append("text").transition().duration(1000).text(`${Math.round(100 * (opt1Point / maxPoint))}pt`).attr("x", opt1BarScale(100 * (opt1Point / maxPoint) + 1)).attr("font-size", 14).attr("font-weight", "bold")

    const opt2Bar = bounds.append("g").attr("transform", "translate(400,350)")

    const opt2BarScale = d3.scaleLinear().domain([
      0, 100 * (((opt2Max - opt2Min) / maxPoint))
    ]).range([
      0,
      (((opt2Max - opt2Min) / maxPoint)) * totalWidth * 100
    ])
    const opt2BarAxisGenerator = d3.axisBottom().scale(opt2BarScale).ticks(2)
    const opt2BarText = opt2Bar.append("text").text("Other pelvic tissue except uterus and tube [Macroscopic]").attr("text-anchor", "start").attr("x", -440).attr("font-weight", "bold")
    const opt2BarAxis = opt2Bar.append("g").call(opt2BarAxisGenerator)
    const opt2Rect = opt2Bar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", opt2BarScale(100 * (opt2Point / maxPoint))).attr("fill", i(opt2Point / (opt2Max - opt2Min)))
    const opt2Text = opt2Bar.append("text").transition().duration(1000).text(`${Math.round(100 * (opt2Point / maxPoint))}pt`).attr("x", opt2BarScale(100 * (opt2Point / maxPoint) + 1)).attr("font-size", 14).attr("font-weight", "bold")



    // Prob Bar
    const probBar = bounds.append("g").attr("transform", "translate(400,450)")

    const probBarScale = d3.scaleLinear().domain([0, 1]).range([
      0, totalWidth * 100
    ])
    const probBarAxisGenerator = d3.axisBottom().scale(probBarScale)
    const probBarText = probBar.append("text").text("Probability of being resistant to platinum").attr("text-anchor", "start").attr("x", -440).attr("font-weight", "bold")
    const probBarAxis = probBar.append("g").call(probBarAxisGenerator)
    const probRect = probBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", probBarScale(prob)).attr("fill", i(prob))
    const probText = probBar.append("text").transition().duration(1000).text(`${Math.round(100 * prob)}%`).attr("x", probBarScale(prob) + 5).attr("font-size", 15).attr("font-weight", "bold")

    const riskGroup = bounds.append("g").attr("transform", "translate(400,500)")
    const riskGroupText = riskGroup.append("text").text("Risk group[cut-off:41pt]").attr("text-anchor", "start").attr("x", -440).attr("font-weight", "bold")


    function HighLow(totalPoint) {
      console.log("Total Point", totalPoint)
      if (Math.round(100 * (totalPoint / maxPoint)) > 40) {
        return "High-risk"
      }
      else {
        return "Low-risk"
      }
    }
    const HighriskGroup = bounds.append("g").attr("transform", "translate(400,500)")
    const riskGroupResult = HighriskGroup.append("text").text(HighLow(totalPoint)).attr("text-anchor", "start").attr("text-anchor", "start").attr("x", 0).attr("font-weight", "bold")



  }, [props.data])

  return (<Box border="3px solid gray">
    <svg ref={ref} />
  </Box>)
}

export default Output1
